var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonitoring = function SvgMonitoring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7356BF",
    d: "M18.3335 15.834H2.49951V14.167H18.3335V15.834ZM18.3335 12.5H2.49951V10.834H18.3335V12.5ZM6.07471 3.8916C7.12119 2.93233 8.75634 3.03542 9.67334 4.11914L12.0161 6.88867C12.3218 7.24967 12.8666 7.28441 13.2153 6.96484L16.937 3.55273C17.2763 3.24191 17.8038 3.26529 18.1147 3.60449C18.4253 3.94374 18.402 4.47038 18.063 4.78125L14.3413 8.19336C13.2948 9.15242 11.6606 9.04849 10.7437 7.96484L8.40088 5.19629C8.09524 4.83508 7.55049 4.80045 7.20166 5.12012L3.47998 8.53125C3.14072 8.84224 2.61324 8.81971 2.30225 8.48047C1.99125 8.1412 2.01474 7.61373 2.354 7.30273L6.07471 3.8916Z"
  })));
};
export default SvgMonitoring;